<template>
  <div class="backTop_box">
    <div class="backTop" >
      
      <el-popover
        placement="right"
        width="232"
        trigger="hover">
        <div class="ewm_box" >
          <img src="@/assets/ewm.png" alt="">
          <div class="ewm_box_right">
            <p class="text">关注公众号获取更多信息</p>
            <p>扫码关注</p>
          </div>
        </div>
        <div class="ewm" slot="reference">
          <span  class="iconfont iconerweima" ></span>
        </div>
      </el-popover>
      <div class="gotop" @click="gotop">
        
        <span class="iconfont icontop"></span>
      </div>
    </div>
    
  </div>
  


</template>

<script>
import QRCode from 'qrcodejs2'
import bus from '@/utils/bus'
export default {
  name: 'backTop',

  data() {
    return {
      show:false
    }
  },
  created() {

  },
  components:{
    QRCode
  },
  mounted () {    
    bus.$on('gotop', this.gotop)  
  },
  methods: {
    gotop(){
       var _backToTop = function _backToTop() {
          var y = window.pageYOffset;
          window.scrollTo(0, Math.floor(y / 1.5));

          if (y > 0) window.requestAnimationFrame(_backToTop);
        };
        _backToTop();
    },
    
    init(){
      let _this=this
      
    //   let qrcode=new QRCode('qrcode',{
    //     width:120,
    //     height:120,
    //     text:_this.url,
    //     colorDark:'#000',
    //     colorLight:'#fff'
    //   })
    }
  }
}
</script>

<style lang="less" scoped>
.backTop_box{
  position:fixed;
  bottom:195Px;
  margin-left:340Px;
  width:300Px;
}
.backTop{
  width:48Px;height:100Px;
  float:left;
  margin-right:10Px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(229, 229, 229, 1);
  .ewm,.gotop{
    width:100%;height:50Px;
    text-align: center;
    line-height:45Px;
    cursor: pointer;
    .iconfont{
      font-size:25Px;
    }
    &:hover{
      color:#1890FF;
    }
  }
  .ewm{
    border-bottom:1px solid #E5E5E5;
    
  }
}
.ewm_box{
  float:left;
  width:232Px;
  height:100Px;
  position:relative;top:24Px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(229, 229, 229, 1);
  box-sizing: border-box;
  padding:10Px 10Px;
  img{
    float:left;
  }
  .ewm_box_right{
    padding-left:85Px;
    padding-top:2Px;
    p{
      color:#2A9519;
    }
    .text{
      font-size:12Px;
      color:#999999;
    }

  }
}


</style>
